var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.837 4.516c-.418.408-4.502 4.695-4.502 4.695a1.095 1.095 0 000 1.576s4.084 4.289 4.502 4.695c.418.408 1.17.436 1.615 0 .446-.434.481-1.041 0-1.574L8.705 10l3.747-3.908c.481-.533.446-1.141 0-1.576-.445-.436-1.197-.409-1.615 0z"
  })));
}
export default SvgChevronLeftArrow;